var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcRankedKeywordNewBadge = function SvgIcRankedKeywordNewBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    d: "M7.042 10H5.484L2.862 6.187h-.049V10H.958V2.93h1.587l2.583 3.803h.059V2.93h1.855z"
  })));
};
export default SvgIcRankedKeywordNewBadge;